
import { MapConfig } from 'lib-customizations/types'
const mapConfig: MapConfig = {
  center: [64.13075, 28.39055],
  initialZoom: 13,
  addressZoom: 14,
  searchAreaRect: {
    maxLatitude: 64.4097021115188,
    minLatitude: 61.05848873922288,
    maxLongitude: 28.573479607294263,
    minLongitude: 28.203159107936858,
  },
  careTypeFilters: ['DAYCARE', 'PRESCHOOL', 'CLUB'],
  unitProviderTypeFilters: [
    'MUNICIPAL',
    'PURCHASED',
    'PRIVATE',
    'PRIVATE_SERVICE_VOUCHER',
  ],
}

export default mapConfig
